<template>
  <c-transition>
    <c-tooltip
      class="tooltip"
      v-bind="$attrs"
    >
      <div
        v-for="info in infoList"
        :key="info.value"
        :class="[ 'info', {
          '-center': textAlign === 'center',
          '-right': textAlign === 'right',
          '-left': textAlign === 'left',
        } ]"
      >
        <span
          v-if="info.title"
          :class="[ 'title', {
            '-has-value': info?.value
          } ]">
          {{ info.title }}
        </span>

        <span
          v-if="info.value"
          class="value">
          {{ info.value }}
        </span>
      </div>
    </c-tooltip>
  </c-transition>
</template>

<script>
import { defineComponent } from 'vue'
import { CTransition, CTooltip } from '@convenia/components/index'

const checkPlacement = (types, v) => typeof v === 'string' && types.indexOf(v) > -1

export default defineComponent({
  name: 'TooltipInfo',

  components: {
    CTransition,
    CTooltip,
  },

  props: {
    /**
     * Information to be displayed.
     * @type {Item[]}
     */
    infoList: {
      type: Array,
      default: () => [],
    },

    /**
     * Content alignment, which can be center, right, or left.
     * @type {String}
     */
    textAlign: {
      type: String,
      default: 'center',
      validator: v => checkPlacement([ 'right', 'center', 'left' ], v)
    },
  },
})
</script>

<style lang="scss">
.tooltip > .popover > .card > .info {
  margin-bottom: 5px;

  &.-center {
    text-align: center;
  }

  &.-right {
    text-align: right;
  }

  &.-left {
    text-align: left;
  }

  &:last-child {
    margin-bottom: 0;
  }

  & > .title {
    display: block;
    font-family: var(--title-font-family);
    font-size: 11px;
    font-weight: var(--title-font-weight);
    line-height: 14px;
    text-transform: uppercase;

    &.-has-value {
      margin-bottom: 5px;
    }
  }

  & > .value {
    display: block;
    font-family: var(--base-font-family);
    font-size: 14px;
    font-weight: var(--base-font-weight);
    line-height: 19px;
  }
}
</style>
